import { render, staticRenderFns } from "./AppNavbarFull.vue?vue&type=template&id=63d5f887"
import script from "./AppNavbarFull.vue?vue&type=script&lang=js"
export * from "./AppNavbarFull.vue?vue&type=script&lang=js"
import style0 from "./AppNavbarFull.vue?vue&type=style&index=0&id=63d5f887&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports